import IframeActivity from "./IframeActivity";

export default function ThinkWithYourHands() {
    return (
        <IframeActivity
            src="/activities/think-with-your-hands/index.html"
            title="Think with Your Hands"
        />
    );
}